import { TagEntityResource } from './Tag';

export const transformToTag = (resource?: TagEntityResource): string => {
    if (!resource?.attributes?.tag) return '';

    return resource.attributes.tag;
};
